<div class="port-services-panel__item" [class.active]="active()">
  <div class="port-services-panel__item-left">
    <service-icon size="s" [type]="iconType()" [firewallEnabled]="isFirewall()" />
    <span class="port-services-panel__item-title">{{ title() }}</span>
  </div>
  <div class="port-services-panel__item-right">
    @if (!isMsc()) {
      <span> {{ serviceSpeed() | service_speed }} </span>
    } @else {
      <span>-</span>
    }
    <svg-icon src="assets/images/icons/arrow-small-right.svg"></svg-icon>
  </div>
</div>
